function Contact() {
  return (
    <div className="bg-navy-light py-20 px-8" id="contact">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-slate-light mb-2">
          <span className="text-green font-mono text-xl">05. </span>
          Get In Touch
        </h2>
        <div className="w-64 h-px bg-navy-lighter mb-10 mx-auto"></div>
        <p className="text-slate mb-10">
          Currently open to SRE, CloudOps, and DevOps opportunities.
          Feel free to reach out.
        </p>
        <div className="flex justify-center gap-8 flex-wrap">
          <a href="mailto:digamdip@gmail.com"
            className="border border-green text-green px-8 py-3 rounded hover:bg-green hover:text-navy transition-all">
            Say Hello
          </a>
          <a href="https://linkedin.com/in/digamber-dwivedi" target="_blank" rel="noreferrer"
            className="border border-slate text-slate px-8 py-3 rounded hover:border-green hover:text-green transition-all">
            LinkedIn
          </a>
          <a href="https://github.com/digamber-dwivedi" target="_blank" rel="noreferrer"
            className="border border-slate text-slate px-8 py-3 rounded hover:border-green hover:text-green transition-all">
            GitHub
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;